// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockAsset {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, blockBackgroundColor) {
        var _a, _b, _c, _d;
        this.assetId = model.componentAssetId;
        // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
        this.title = ((_a = model.title) === null || _a === void 0 ? void 0 : _a.length) > 0 ? model.title : null;
        // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
        this.description = ((_b = model.description) === null || _b === void 0 ? void 0 : _b.length) > 0 ? model.description : null;
        this.backgroundColor = (_d = (_c = model.backgroundColor) !== null && _c !== void 0 ? _c : blockBackgroundColor) !== null && _d !== void 0 ? _d : null;
    }
}
